import _extends from "@babel/runtime/helpers/extends";
import * as React from 'react';
export function ChevronIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 10 6"
  }, props), /*#__PURE__*/React.createElement("path", {
    fill: "#C3C3C3",
    d: "M4.3 5.7L.1 1.6C-.2 1.2-.1.6.2.3c.3-.4.9-.4 1.3-.2L5 3.4 8.4.1c.4-.3 1-.2 1.3.2.3.4.4.9.1 1.3L5.6 5.7c-.2.2-.4.3-.6.3-.2 0-.5-.1-.7-.3z"
  }));
}